const Roles = {
  administrator: 'administrator',
  lead: 'lead',
  organizer: 'organizer',
  activist: 'activist',
  Administrator: 'Administrator',
  Lead: 'Lead',
  Organizer: 'Organizer',
  Activist: 'Activist',
};

const Masks = {
  PhoneRegular: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  PhoneIntl: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  Decimals: []
};

const LONG_DASH = '–';

export {
  Roles,
  Masks,
  LONG_DASH
};
